import { forwardRef } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

const noop = () => {};

// @tawk.to/tawk-messenger-react relies on `defaultProps` for its ~20 event
// callbacks (onBeforeLoad, onStatusChange, etc.), but React 19 no longer
// supports defaultProps on forwardRef/function components — every callback
// we don't pass ends up `undefined`, and the library calls it directly
// (e.g. `props.onBeforeLoad()`), crashing the app. We pass explicit no-ops
// for all of them here to work around that.
const TAWK_NOOP_CALLBACKS = {
  onLoad: noop,
  onStatusChange: noop,
  onBeforeLoad: noop,
  onChatMaximized: noop,
  onChatMinimized: noop,
  onChatHidden: noop,
  onChatStarted: noop,
  onChatEnded: noop,
  onPrechatSubmit: noop,
  onOfflineSubmit: noop,
  onChatMessageVisitor: noop,
  onChatMessageAgent: noop,
  onChatMessageSystem: noop,
  onAgentJoinChat: noop,
  onAgentLeaveChat: noop,
  onChatSatisfaction: noop,
  onVisitorNameChanged: noop,
  onFileUpload: noop,
  onTagsUpdated: noop,
  onUnreadCountChanged: noop,
};

// Live chat widget (Tawk.to). Mounted once; the bubble is always visible
// (Tawk's own default behavior), and can be auto-opened on demand via ref
// (e.g. from the "Get Started" signup modal's "Chat with us live" button).
const TawkChat = forwardRef(function TawkChat(_props, ref) {
  const propertyId = process.env.REACT_APP_TAWK_PROPERTY_ID;
  const widgetId = process.env.REACT_APP_TAWK_WIDGET_ID;
  if (!propertyId || !widgetId) return null;

  return (
    <TawkMessengerReact
      propertyId={propertyId}
      widgetId={widgetId}
      ref={ref}
      {...TAWK_NOOP_CALLBACKS}
    />
  );
});

export default TawkChat;
